/**
 * Global constants used across the app.
 * Single source of truth for configuration values.
 */

/** Cache TTL in days — stale entries older than this are filtered out on save */
export const CACHE_TTL_DAYS = 7;

/** Cycle day test recommendation window */
export const CYCLE_DAY_TEST_START = 11;
export const CYCLE_DAY_TEST_END = 18;

/** Cycle day test underline window (peak fertility window) */
export const CYCLE_DAY_TEST_UNDERLINE_START = 12;
export const CYCLE_DAY_TEST_UNDERLINE_END = 16;
